import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import moment from 'moment'

import * as higherAdjustmentsActions from 'action/higherAdjustments'
import * as reportActions from 'action/report'

import CommonReport from 'component/commonReport/CommonReport'
import columns from 'component/higherAdjustments/columns'
import { renderToastWarn } from 'utils/ToastUtils'
import applyMask from 'component/report/utils/Formatter'

class HigherAdjustments extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    fetchHigherAdjustments: PropTypes.func,
    error: PropTypes.object,
    count: PropTypes.number.isRequired,
    records: PropTypes.array.isRequired,
    fetchReports: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
  }

  state = {
    formData: {},
    lm: '',
    subtypesQuery: false,
  }

  getFormFields() {
    const { translate } = this.props
    const { lm } = this.state
    const fields = [
      {
        type: 'branchs',
        name: 'idBranches',
        label: translate('field.store'),
        help_text: translate('mobile.hint.store'),
        required: true,
      },
      {
        type: 'sections',
        name: 'lsSections',
        label: translate('section'),
        help_text: translate('mobile.hint.section'),
        onChangeValue: (e) => {
          const query = { sectionIdList: e }
          this.setState({ subtypesQuery: query })
        },
        attrs: {
          disabled: lm.length > 0,
        },
      },
      {
        type: 'select',
        name: 'fieldsValue',
        label: translate('orderBy.label'),
        help_text: translate(
          'higher.adjustments.select.optionsValueOrQQt.helpText'
        ),
        options: [
          {
            value: 'quantity',
            label: translate('order.quantity_label'),
          },
          {
            value: 'value',
            label: translate('order_status.value'),
          },
        ],
      },
      {
        type: 'date_range',
        name: 'period',
        label: translate('field.period.hint'),
        required: true,
      },
    ]
    return fields
  }

  getColumns() {
    const { translate } = this.props

    const cols = {}

    for (const col of columns) {
      if (col.render) {
        cols[col.field] = {
          fixed: col.fixed,
          label: translate(col.headerLabel),
          align: col.align,
          customWidth: col.customWidth || false,
          disableOrder: col.field !== 'dtInclusion',
        }
      }
    }

    return cols
  }

  buildRows() {
    const { records, translate } = this.props

    const rows = []
    let i = 0

    for (const rec of records || []) {
      rows[i] = {}
      for (const col of columns) {
        if (col.render) {
          if (rec[col.field]) {
            rows[i][col.field] = applyMask(
              col.type,
              rec[col.field],
              translate,
              col.headerLabel
            )
            if (col.field === 'ranking') {
              rows[i][col.field] += '°'
            }
            if (['qqtAdjust', 'total'].indexOf(col.field) !== -1) {
              if (
                rows[i][col.field] &&
                rows[i][col.field].toString().indexOf('-') !== -1
              ) {
                rows[i][col.field] = `<b class='color-danger'>${
                  rows[i][col.field]
                }</b>`
              }
            }
          } else {
            rows[i][col.field] = '-'
          }
        }
      }
      i++
    }

    return rows
  }

  onSubmit = async (data, callback) => {
    const {
      auth: {
        user: { dsToken },
      },
      fetchHigherAdjustments,
    } = this.props

    if (data && data.period && data.period[0]) {
      const momentDate = moment(data.period[0])
      data.dtStart = momentDate.format('DD/MM/YYYY')
    }
    if (data && data.period && data.period[1]) {
      const momentDate = moment(data.period[1])
      data.dtEnd = momentDate.format('DD/MM/YYYY')
    }
    data.size = 10
    data.hasPagination = true
    this.setState({ formData: data })

    await fetchHigherAdjustments(dsToken, data)
    if (this.props.error) {
      renderToastWarn(this.props.error)
    } else {
      const content = {
        data: this.buildRows(),
        total: this.props.count,
      }
      callback(content)
    }
  }

  onExport = async (callback) => {
    const {
      auth: {
        user: { dsToken },
      },
      fetchReports,
    } = this.props

    const { formData } = this.state

    await fetchReports(dsToken, { tpReport: 13 }, formData)

    const callbackReturn = true
    callback(callbackReturn)
  }

  render() {
    const { translate } = this.props
    return (
      <CommonReport
        translate={translate}
        title={translate('higher.adjustments.title')}
        onSubmit={this.onSubmit}
        onExport={this.onExport}
        fields={this.getFormFields()}
        columns={this.getColumns()}
        order
        defaultOrder='dtInclusion'
        emptyReportMsg='rotativeInventory.not-found'
      />
    )
  }
}

const mapStateToProps = ({
  higherAdjustmentsReducer,
  paginateReducer,
  reportReducer,
}) => ({
  count: paginateReducer.count,
  current: paginateReducer.current,
  error: reportReducer.get.error,
  pages: paginateReducer.pages,
  records: higherAdjustmentsReducer.records,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...higherAdjustmentsActions, ...reportActions },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    HigherAdjustments
  )
)
export { HigherAdjustments }
